import { createFileRoute } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'

// パートナーユーザーも配車板に入れる（#5600）。見える範囲と操作は画面と API 側で制御する
export const Route = createFileRoute(
  '/_protected/$tenantKey/vehicle-dispatch-boards'
)({
  meta: () => [
    {
      title: MENU.VEHICLE_DISPATCH_BOARD
    }
  ],
  staticData: {
    stickyHeader: true
  }
})
